import React from "react";
import { Box, Link as MUILink } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";

const LINKS = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms & Conditions", to: "/terms-and-conditions" },
  { label: "Refund & Cancellation Policy", to: "/refund-and-cancellation-policy" },
  { label: "Cookie Policy", to: "/cookie-policy" },
];

export default function LegalNav() {
  const { pathname } = useLocation();

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1.2,
        borderBottom: "1px solid #eee",
        pb: 3,
        mb: 1,
      }}
    >
      {LINKS.map((link) => {
        const active = pathname === link.to;
        return (
          <MUILink
            key={link.to}
            component={RouterLink}
            to={link.to}
            underline="none"
            sx={{
              fontSize: "0.85rem",
              fontWeight: 600,
              px: 1.8,
              py: 0.7,
              borderRadius: "20px",
              color: active ? "#fff" : "#000",
              backgroundColor: active ? "#e3242b" : "#f2f2f2",
              transition: "all 0.25s ease",
              "&:hover": {
                backgroundColor: active ? "#e3242b" : "#e6e6e6",
              },
            }}
          >
            {link.label}
          </MUILink>
        );
      })}
    </Box>
  );
}
